function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("rect", {
  stroke: "#D3D3D3",
  fill: "#FFF",
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 23,
  rx: 4
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M14 23h18.033C33.63 23 35 21.67 35 20.05V13c-6 4.884-13.08 8.256-21 10z",
  fill: "#E67E22"
}),
/*#__PURE__*/
React.createElement("text", {
  fontFamily: "AvenirNext-DemiBold, Avenir Next",
  fontSize: 11,
  fontWeight: 500,
  fill: "#34495E"
},
/*#__PURE__*/
React.createElement("tspan", {
  x: 4,
  y: 16
}, "DISC")));

var SvgDiscoverCard = function SvgDiscoverCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 36 24",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgDiscoverCard, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/DiscoverCard.5ce031ef.svg";
export { ForwardRef as ReactComponent };